import $ from 'jquery';
$(function () {
    initCourseLinks();

    function initCourseLinks() {
        function setCourseLink(isFullyBooked, courseUrl) {
            if (isFullyBooked)
                return;

            $("#courseBtnLink").attr("href", courseUrl).removeAttr('disabled');
        }

        $(".selectCourse").click(function (event) {
            setCourseLink($(this).attr("data-fullybooked") === "true", $(this).attr("data-url"));
        });

    }

    var input = $("#searchReport");

    if (input.length) {
        initSearchReport();
    }

    function initSearchReport() {
        var actionUrl = input.attr("data-action");
        var businessFactProductId = $("#hidBusinessFactProductId");
        var productDropdown = $(".dropdown-toggle");
        var submitBtn = $(".initorder__btn");
        productDropdown.click(function() {
            input.autocomplete("search");
        });

        input.autocomplete({
            appendTo: ".report-dropdown",
            classes: {
                "ui-autocomplete": "report-dropdown",
            },
            source: function(request, response) {
                $.ajax({
                    url: actionUrl,
                    method: "POST",
                    dataType: "json",
                    cache: false,
                    contentType: 'application/json; charset=utf-8',
                    data: JSON.stringify({
                        productFamily: input.attr("data-productFamilyId"),
                        search: input.val()
                    }),
                    success: function(data) {
                        $("#reportCaret").attr("class", "fas fa-caret-down");
                        response(data);
                    },
                });
            },
            search: function(event, ui) {
                $("#reportCaret").attr("class", "fas fa-spin fa-spinner");
            },
            select: function(event, ui) {
                businessFactProductId.val(ui.item.value);
                submitBtn.attr("disabled", false);
            },
            minLength: 3,
        }).data("ui-autocomplete")._renderItem = function(ul, item) {
            return $("<li></li>")
                .data("item.autocomplete", item)
                .append("<a class='report-item'><strong>" + item.label + "</strong>" + "</a>")
                .appendTo(ul);
        };
    }
    
    $("#sales-Package-tab").click(function() {
        $("#sales-Package-Price").show();
        $("#seminar-course-price").hide();
    });
    
    $("#seminar-tab").click(function(e){
        setCoursePrice();
    });
    
    function setCoursePrice() {
        var seminarRadios = $(".radio-course input[type='radio']");
        var selected = seminarRadios.filter(":checked");

        if(!selected.length){
            selected = seminarRadios.first();
            selected.prop("checked", true);
            selected.parentsUntil(".selectCourse").click();
        }

        if (selected.length) {
            $("#seminar-course-price h3").html(selected.data("course-price"));
            $("#seminar-course-price").show();
            $("#sales-Package-Price").hide();
        }
    }
    
    $(".radio-course input[type='radio']").click(function() {
        setCoursePrice();
    })
});